import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, TextField, Button } from "@mui/material";
import { useWeb3Context } from "web3-react";
import { useSnackbar } from "notistack";
import { useAuthContext } from "../../context/AuthContextProvider";
import { getProviderOrSigner } from "../../utils";
import axios from "axios";

const IncreDecre = ({
  onBuy,
  disabled,
  title,
  titleMintForMe,
  onMintForMe,
}) => {
  const { account, library, setConnector } = useWeb3Context();

  const [number, setNumber] = useState(1);
  const { enqueueSnackbar } = useSnackbar();
  const { setAuthToken } = useAuthContext();

  const userSignIn = async () => {
    if (account != null) {
      const signer = getProviderOrSigner(library, account);
      const sign = await signer.signMessage(account);
      axios
        .post("login", { account: account, sign: sign })
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            const token = response.data.token;
            setAuthToken(token);
            enqueueSnackbar("Connected successfully...!!!", {
              variant: "success",
              autoHideDuration: 1500,
            });
          }
        })
        .catch((error) => {
          enqueueSnackbar(error.message, {
            variant: "error",
            autoHideDuration: 1500,
          });
          // console.log(error.message);
        });
    }
  };
  const handleAccount = () => {
    setConnector("Injected", { suppressAndThrowErrors: true })
      .then((result) => {
        userSignIn();
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
          autoHideDuration: 1500,
        });
      });
  };
  const increNumber = () => {
    number >= 0 ? setNumber(number + 1) : setNumber(number);
  };
  const decrNumber = () => {
    number > 0 ? setNumber(number - 1) : setNumber(number);
  };
  return (
    <>
      <Box display="flex" flexDirection="row" sx={{ width: "fit-content" }}>
        <Box display="flex" flexDirection="row">
          <RemoveIcon
            onClick={decrNumber}
            sx={{ marginTop: "0.3rem", cursor: "pointer" }}
          />
          <TextField
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            id="outlined-basic"
            variant="outlined"
            sx={{
              width: "48px",
              "& input": {
                height: "0px",
                textAlign: "center",
              },
            }}
          />
          <AddIcon
            onClick={increNumber}
            sx={{ marginTop: "0.3rem", cursor: "pointer" }}
          />
          {/* <AddIcon  /> */}
        </Box>
      </Box>
      <Button
        variant="contained"
        sx={{
          fontWeight: "bold",
          margin: "20px 0px",
          fontSize: "70%",
        }}
        disabled={disabled}
        onClick={
          account
            ? () => {
                if (number === 0) {
                  alert("Select at least one in quantity");
                } else {
                  onBuy(number);
                }
              }
            : handleAccount
        }
      >
        {/* {account ? title : ""} */}
        {title}
      </Button>
      {titleMintForMe && (
        <Button
          variant="contained"
          sx={{
            fontWeight: "bold",
            margin: "20px 0px",
            fontSize: "70%",
            marginLeft: "10px",
          }}
          disabled={disabled}
          onClick={
            account
              ? () => {
                  if (number === 0) {
                    alert("Select at least one in quantity");
                  } else {
                    onMintForMe(number);
                  }
                }
              : handleAccount
          }
        >
          {/* {account ? titleMintForMe : "Mint for Me"} */}
          {titleMintForMe}
        </Button>
      )}
    </>
  );
};

export default IncreDecre;
